import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsGuest } from 'redux/db/reducers';
import * as S from './styles';

interface NavbarProps {
	children: React.ReactNode;
	layout?: 'centered' | 'left-aligned';
}

const Navbar = React.forwardRef<HTMLDivElement, NavbarProps>(({ children, layout }, ref) => {
	const { sidebarDocked, isGuest } = useSelector((r: RootReducer) => {
		return {
			sidebarDocked: r.mode.sidebarDocked,
			isGuest: selectIsGuest(r.db),
		};
	}, shallowEqual);

	const makeSpaceForSidebar = !isGuest && !sidebarDocked;

	return (
		<S.Base ref={ref} makeSpaceForSidebar={makeSpaceForSidebar} $layout={layout}>
			{children}
		</S.Base>
	);
});

Navbar.displayName = 'Navbar';

export default Navbar;
